import { ToggleGroup } from '@ps/isp-web-component-library';
import { LiveData as LiveDataIcon } from '@ps/isp-web-component-library/icons/LiveData';
import { LiveStreaming as LiveStreamIcon } from '@ps/isp-web-component-library/icons/LiveStreaming';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { LiveOption } from '@swf/sports/types/liveOption';

import { TXTWCL_Live_Data, TXTWCL_Live_Stream } from './LiveOptions.messages.json';

interface LiveOptionsProps {
  handleToggleGroupChange: (value: LiveOption) => void;
  hasLiveDataAvailable?: boolean;
  hasLiveStreamAvailable?: boolean;
  variant?: 'standard' | 'plain';
  liveDataIcon?: typeof LiveDataIcon;
  liveStreamIcon?: typeof LiveStreamIcon;
}

const LiveOptions: React.FC<LiveOptionsProps> = ({
  handleToggleGroupChange,
  hasLiveDataAvailable,
  hasLiveStreamAvailable,
  variant,
  liveDataIcon,
  liveStreamIcon
}) => {
  const { formatMessage } = useRegulatoryIntl();

  const handleChange = (value: string) => {
    if (!value || Object.values(LiveOption).includes(value as LiveOption)) {
      handleToggleGroupChange(value as LiveOption);
    }
  };

  return hasLiveDataAvailable || hasLiveStreamAvailable ? (
    <ToggleGroup onChange={handleChange} variant={variant}>
      {hasLiveDataAvailable ? (
        <ToggleGroup.Item
          icon={liveDataIcon || LiveDataIcon}
          label={formatMessage(TXTWCL_Live_Data)}
          value={LiveOption.LIVE_DATA}
        />
      ) : null}
      {hasLiveStreamAvailable ? (
        <ToggleGroup.Item
          icon={liveStreamIcon || LiveStreamIcon}
          label={formatMessage(TXTWCL_Live_Stream)}
          value={LiveOption.LIVE_STREAM}
        />
      ) : null}
    </ToggleGroup>
  ) : null;
};

export default LiveOptions;
